// extracted by mini-css-extract-plugin
export default {"Map":"Map_Map__1ZSXo","Map__preloader":"Map_Map__preloader__2nIFO"};